// J-245 (the owner's order of 2026-10-16, item 4a): Settings' password page, where any signed-in user
// changes their own password with Better Auth's `/change-password`. Every role reaches it: it asks for no
// permission, and the top bar's user menu links it on every screen. A successful change signs the
// account's other sessions out; this browser stays signed in.
import * as React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { AlertBanner } from "@vbltc/ui/components/alert-banner/alert-banner";
import { ChangePasswordForm } from "@/features/auth/components/change-password-form";

export const Route = createFileRoute("/_authenticated/settings_/password")({
  staticData: { screenName: "Change password" },
  component: SettingsPasswordPage,
});

function SettingsPasswordPage() {
  const [changed, setChanged] = React.useState(false);
  return (
    <section aria-label="Change password" className="grid max-w-2xl gap-4 pt-2">
      <p className="text-sm">Change the password you sign in with.</p>
      {changed ? (
        <AlertBanner
          variant="info"
          live
          title="Password changed"
          onDismiss={() => setChanged(false)}
        >
          Your password was changed. Your other sessions were signed out.
        </AlertBanner>
      ) : null}
      <ChangePasswordForm onChanged={() => setChanged(true)} />
    </section>
  );
}
